module.exports = __webpack_public_path__ + "static/media/remidio-normal.5c04602f.svg";